import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import CarouselGet from '../services/CarouselGet';
import GamesGetLatest from '../services/GamesGetLatest';
import NewsGetLatest from '../services/NewsGetLatest';

function Home() {
  return (
    <div>
      <Container>
        <CarouselGet />
        <hr />
        <NewsGetLatest />
        <hr />
        <GamesGetLatest />
      </Container>
    </div>

  );
}

export default Home;
